import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InboxOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { LicenseActivationRevokeConfirm } from "./licenseActivationRevokeConfirm.js";
import { LicenseActivationRow } from "./licenseActivationRow.js";
import { RealCommerceError } from "../../../../../../exceptions/realCommerceError.js";
import { __ } from "../../../../../../utils/i18n.js";
import { useAccountV2ErrorHandling } from "../../../../hooks/useAccountV2ErrorHandling.js";
const LicenseActivationsTable = observer(({ license, isReadOnly })=>{
    const handleRealCommerceError = useAccountV2ErrorHandling();
    const [revokeTarget, setRevokeTarget] = useState();
    useEffect(()=>{
        // Activations live on the License model and survive collapse/expand
        // cycles. Skip the refetch if we already loaded them once; revoking
        // an activation prunes the map locally so it stays accurate.
        if (license.activations.size > 0) {
            return;
        }
        license.fetchActivations().catch((e)=>{
            if (e instanceof RealCommerceError) {
                handleRealCommerceError(e);
            }
        });
    }, [
        license
    ]);
    const records = Array.from(license.activations.values());
    if (license.isBusy && records.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "rc-account-v2-subscription-card__activations-loading",
            children: /*#__PURE__*/ _jsx(Spin, {
                size: "small"
            })
        });
    }
    if (records.length === 0) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-subscription-card__activations-empty",
            children: [
                /*#__PURE__*/ _jsx(InboxOutlined, {
                    "aria-hidden": true
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: __("No websites use this license key right now.")
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-subscription-card__activations-list",
                children: records.map((activation)=>/*#__PURE__*/ _jsx(LicenseActivationRow, {
                        activation: activation,
                        isReadOnly: isReadOnly,
                        onRevoke: setRevokeTarget
                    }, activation.data.id))
            }),
            revokeTarget && /*#__PURE__*/ _jsx(LicenseActivationRevokeConfirm, {
                license: license,
                activation: revokeTarget,
                onClose: ()=>setRevokeTarget(undefined)
            })
        ]
    });
});
export { LicenseActivationsTable };
